<template>
  <div class="exammanagement_body">
    <div style="display: flex; justify-content: center">
      <span style="font-weight: bold; font-size: 18px">考试管理</span>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div style="display: flex; padding-top: 20px">
            <a-button type="primary" @click="opendialog">添加考试</a-button>
          </div>
          <div style="padding-top: 10px">
            <el-table :data="examData" border style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="title" label="考试名称" align="center">
              </el-table-column>
              <el-table-column align="center" label="开始时间">
                <template slot-scope="scope">
                  <span>{{
                    dayjs(scope.row.start).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="结束时间">
                <template slot-scope="scope">
                  <span>{{
                    dayjs(scope.row.end).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteexam(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <div>
        <el-dialog
          title="添加"
          :visible.sync="centerDialogVisible"
          width="40%"
          center
        >
          <div>
            <div
              style="
                display: flex;
                justify-content: center;
                flex-direction: column;
              "
            >
              <div style="width: 90px; display: flex; align-items: center">
                <span>考试名称：</span>
              </div>
              <el-input v-model="testname"></el-input>
              <div style="width: 90px; display: flex; align-items: center">
                <span>开始时间：</span>
              </div>
              <el-date-picker
                style="width: 100%"
                value-format="timestamp"
                v-model="starttime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              <div style="width: 90px; display: flex; align-items: center">
                <span>结束时间：</span>
              </div>
              <el-date-picker
                style="width: 100%"
                value-format="timestamp"
                v-model="endtime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
            <p style="margin-top: 20px">添加试卷:</p>
            <div style="padding-top: 10px">
              <el-table
                :data="tableData"
                border
                @selection-change="handleSelectionChange"
                style="width: 100%"
              >
                <el-table-column type="selection" align="center" width="55">
                </el-table-column>
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="80"
                >
                </el-table-column>
                <el-table-column prop="title" align="center" label="试卷名称">
                </el-table-column>
              </el-table>
            </div>
            <p style="margin-top: 20px">添加学生：</p>
            <el-transfer
              style="margin-left: 60px; margin-top: 10px"
              filterable
              :titles="['未选学生', '已选学生']"
              :filter-method="filterMethod"
              filter-placeholder="请输入账号"
              @change="handlechange"
              v-model="rightList"
              :data="leftList"
            >
            </el-transfer>
            <!--                        <div style="padding-top: 10px;">-->

            <!--                            <el-table-->
            <!--                                    :row-key="getRowKey"-->
            <!--                                    :data="userData.slice((currentPage-1)*pagesize,currentPage*pagesize)"-->
            <!--                                    border-->
            <!--                                    @select="userSelectionChange"-->
            <!--                                    style="width: 100%">-->
            <!--                                <el-table-column-->
            <!--                                        type="selection"-->
            <!--                                        :reserve-selection="true"-->
            <!--                                        align="center"-->
            <!--                                        width="55">-->
            <!--                                </el-table-column>-->
            <!--                                <el-table-column-->
            <!--                                        type="index"-->
            <!--                                        align="center"-->
            <!--                                        label='序号'-->
            <!--                                        width="80">-->
            <!--                                </el-table-column>-->
            <!--                                <el-table-column-->
            <!--                                        prop="userName"-->
            <!--                                        align="center"-->
            <!--                                        label="姓名">-->
            <!--                                </el-table-column>-->
            <!--                            </el-table>-->
            <!--                            <div class="page" style="margin-top: 30px">-->
            <!--                                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
            <!--                                               :current-page="currentPage"-->
            <!--                                               :page-sizes="[10, 50, 100, 200]" :page-size="pagesize"-->
            <!--                                               layout="total, sizes, prev, pager, next, jumper"-->
            <!--                                               :total="userData.length">-->
            <!--                                </el-pagination>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "../content/Login";

export default {
  name: "Exammanagement",
  data() {
    // const generateData = _ => {
    //     const data = [];
    //     const cities = [];
    //     cities.forEach((city, index) => {
    //         data.push({
    //             label: '',
    //             key: '',
    //         });
    //     });
    //     return data;
    // };
    return {
      // 可选课程列表（左边）
      leftList: [],
      // 已选课程列表（右边,只需要key）
      rightList: [],
      value: [],

      centerDialogVisible: false,
      testname: "",
      tableData: [],
      userData: [],
      starttime: "",
      endtime: "",
      selectuserData: [],
      selectpaperData: [],
      examData: [],
      currentIndex: "",
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      // id:''
    };
  },

  methods: {
    handlechange() {
      this.selectuserData = this.rightList;
      console.log(this.rightList);
    },
    // 搜索关键字
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },

    getRowKey(row) {
      return row.id;
    },
    // handleSizeChange: function (size) {
    //     this.pagesize = size;
    //     // console.log(this.pagesize) //每页下拉显示数据
    // },
    // handleCurrentChange: function (currentPage) {
    //     this.currentPage = currentPage;
    //
    //     console.log(this.selectpaperData)
    //     // console.log(this.currentPage) //点击第几页
    // },
    deleteexam(row) {
      let that = this;
      this.$confirm({
        title: "确定要永久删除数据，该数据不可恢复?",
        content: "",
        okType: "danger",
        okText: "删除",
        cancelText: "取消",
        onOk() {
          let url = "/exam/delete?examId=";
          console.log(row);
          that.$axios.delete(url + row.examId).then((resp) => {
            if (resp.data.success) {
              that.$message.success("操作成功！");
              that.getexamlist();
            } else {
              that.$message.error("操作失败！");
            }
          });
        },
        onCancel() {},
      });
    },
    getexamlist() {
      let url = "/exam/list";
      this.$axios.get(url).then((resp) => {
        console.log("kaoshi", resp);
        if (resp.data.success) {
          this.examData = resp.data.result;
        }
      });
    },
    opendialog() {
      this.centerDialogVisible = true;
      this.getpaperlist();
    },
    getuserlist() {
      let url = "/user/list";
      this.$axios.get(url).then((resp) => {
        console.log(resp + "学生列表");
        console.log(resp.data.result.length);
        for (let i = 0; i < resp.data.result.length; i++) {
          if (resp.data.result[i].status === "正常") {
            this.leftList.push({
              label: resp.data.result[i].userName,
              key: resp.data.result[i].userId,
            });
          }
        }
        // console.log(this.leftList.length)
      });
    },
    // 两个数据ID转换的方法
    // changeRefListToCourseIdList(resp, fun) {
    //     let idList = [];
    //     for (let i in resp) {
    //         idList.push(resp.data.result[i].userId);
    //     }
    //     fun(idList);
    // },
    // changeCourseIdListToRefList(data, fun) {
    //     let refList = [];
    //     for (let i in data) {
    //         let studentCourseRef = {
    //             userId: data[i]
    //         }
    //         refList.push(studentCourseRef);
    //     }
    //     fun(refList);
    // },
    getpaperlist() {
      let url = "/paper/list";
      this.$axios.get(url).then((resp) => {
        if (resp.data.code === 200) {
          this.tableData = resp.data.result;
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      for (let i = 0; i < val.length; i++) {
        this.selectpaperData.push(val[i].paperId);
      }
    },
    userSelectionChange(val) {
      console.log(11111111111111);
      for (let i = 0; i < val.length; i++) {
        this.selectuserData.push(val[i].userId);
      }
      // let newData = val.map(data => {
      //     return data.userId
      // })
      // this.selectuserData = newData
      console.log(this.selectuserData);
    },
    submit() {
      let url = "/exam/save";
      let param = {
        title: this.testname,
        start: this.starttime,
        end: this.endtime,
        stuIds: JSON.stringify(this.selectuserData),
        paperIds: JSON.stringify(this.selectpaperData),
      };
      console.log(param);
      this.$axios.post(url, param).then((resp) => {
        console.log(resp);
        if (resp.data.success) {
          this.$message.success("操作成功！");
          this.centerDialogVisible = false;
          this.getexamlist();
        }
      });
    },
  },
  mounted() {
    this.getpaperlist();
    this.getuserlist();
    this.getexamlist();
  },
};
</script>

<style scoped>
.ant-btn-primary {
  color: #ffffff;
  font-weight: bolder;
  background-color: skyblue;
  border-color: skyblue;
}
</style>
